import rubikLightWoff from '@fonts/rubik/rubik-300.woff';
import rubikLightWoff2 from '@fonts/rubik/rubik-300.woff2';
import rubikRegularWoff from '@fonts/rubik/rubik-regular.woff';
import rubikRegularWoff2 from '@fonts/rubik/rubik-regular.woff2';
import rubikMediumWoff from '@fonts/rubik/rubik-500.woff';
import rubikMediumWoff2 from '@fonts/rubik/rubik-500.woff2';
import rubikBoldWoff from '@fonts/rubik/rubik-700.woff';
import rubikBoldWoff2 from '@fonts/rubik/rubik-700.woff2';

const fonts = `
  @font-face {
    font-family: 'Rubik';
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src: local(''), url(${rubikLightWoff}) format('woff'), url(${rubikLightWoff2}) format('woff2');
  }
  @font-face {
    font-family: 'Rubik';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: local(''), url(${rubikRegularWoff}) format('woff'), url(${rubikRegularWoff2}) format('woff2');
  }
  @font-face {
    font-family: 'Rubik';
    font-style: normal;
    font-display: swap;
    font-weight: 500;
    src: local(''), url(${rubikMediumWoff}) format('woff'), url(${rubikMediumWoff2}) format('woff2');
  }
  @font-face {
    font-family: 'Rubik';
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src: local(''), url(${rubikBoldWoff}) format('woff'), url(${rubikBoldWoff2}) format('woff2');
  }
`;

export default fonts;
